import * as Styled from './KPIWidget.styles';
import { Skeleton } from '@mui/material';
import WidgetContainer from './../../Atoms/WidgetContainer/WidgetContainer';

const KPIWidgetSkeleton = ({ previous, error }: { previous: boolean; error?: boolean }) => {
  return (
    <WidgetContainer error={error} skeleton title='Title' infoMessage='' aspectRatio='1.5 / 1'>
      <Styled.KPIColumn>
        {' '}
        <Styled.KPIRow>
          <Skeleton>
            <Styled.KPIValue variant='h2'>{1000}</Styled.KPIValue>
          </Skeleton>
          <Skeleton>
            <Styled.KPIUnit variant='h3'>unit</Styled.KPIUnit>
          </Skeleton>
        </Styled.KPIRow>
        {previous && (
          <Skeleton>
            <Styled.KPIChip>
              <Styled.KPIChipUp title={'Title'} color='success' variant='outlined' label={`50%`} />
            </Styled.KPIChip>
          </Skeleton>
        )}
      </Styled.KPIColumn>
    </WidgetContainer>
  );
};
export default KPIWidgetSkeleton;
